export const requestNotificationPermission = async () => {
  if (!("Notification" in window)) return false;
  if (Notification.permission === "granted") return true;
  if (Notification.permission === "denied") return false;
  const result = await Notification.requestPermission();
  return result === "granted";
};

export const showNotification = (title, options = {}) => {
  if (Notification.permission !== "granted") return;
  const notification = new Notification(title, {
    icon: "/assets/logo.svg",
    badge: "/assets/logo.svg",
    dir: "rtl",
    lang: "he",
    ...options,
  });
  notification.onclick = () => {
    window.focus();
    notification.close();
  };
  return notification;
};

export const isNotificationSupported = () => "Notification" in window;
export const isNotificationGranted = () => Notification.permission === "granted";
